import styled from 'styled-components'
import Colors from 'utils/Colors'

export default styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* padding: 0 2rem; */
  margin-bottom: 2rem;
  
  .content {
    padding: 0 2rem;
  }

  .full_width {
    width: 100%;

    &:not(:first-child) {
      margin: 0 2rem;
    }
  }

  .header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 1.5rem 2rem;
    background-color: ${Colors.loginPrimaryColor};
    width: 100%;
    margin-bottom: 1.5rem;

    @media screen and (max-width: 450px) {
      justify-content: center;
    }
    
    & span, & a {
      text-align: left;

      @media screen and (max-width: 450px) {
        text-align: center;
      }
    }

    &__logo {
      width: 120px;
      height: auto;

      @media screen and (max-width: 450px) {
        width: 40%;
      }
    }
  }
`
